import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';

import useMediaQuery from 'hooks/useMediaQuery';
import useScrollControl from 'hooks/useScrollControl';
import useWishlist from 'hooks/useWishlist';

const AddKeywordToWishlistActionSheet = dynamic(
  () => import('components/AddKeywordToWishlistActionSheet'),
  { ssr: false }
);

const ActionSheet = ({ mostRelevantKeyword = null, photo = null, ...rest }) => {
  const { isLg } = useMediaQuery();
  const { offerWishlist } = useWishlist();
  const { showScrollable } = useScrollControl();

  const isKeywordOnUsersWishlist = useMemo(
    () =>
      offerWishlist?.items.some(
        ({ keywordDisplay }) => keywordDisplay === mostRelevantKeyword
      ),
    [offerWishlist, mostRelevantKeyword]
  );

  const isActive = useMemo(
    () => !isKeywordOnUsersWishlist && !!mostRelevantKeyword,
    [isKeywordOnUsersWishlist, mostRelevantKeyword]
  );

  useEffect(() => {
    if (!isLg || !isActive) {
      return;
    }

    showScrollable(AddKeywordToWishlistActionSheet, {
      gaEventCategory: 'actionsheet_search',
      image: photo,
      isOpen: true,
      keyword: mostRelevantKeyword,
      title: 'Alerta de Promoção',
      children: (
        <>
          Quer receber um alerta quando <b>{mostRelevantKeyword}</b> aparecer?
        </>
      ),
      ...rest,
    });
  }, [isLg, isActive]);

  return null;
};

ActionSheet.propTypes = {
  mostRelevantKeyword: PropTypes.string,
  photo: PropTypes.string,
};

export default ActionSheet;
